import { Input } from "@/components/ui/input";

type MCSettingNumberProps = {
  title: string;
  description?: string;
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
  disabled?: boolean;
};

export function MCSettingNumber({
  title,
  description,
  value,
  min,
  max,
  step,
  onChange,
  disabled,
}: MCSettingNumberProps) {
  return (
    <div className="rounded-2xl border border-border bg-background/60 p-4">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="text-sm font-semibold text-foreground">{title}</p>
          {description && <p className="text-xs text-muted-foreground">{description}</p>}
        </div>
        <Input
          type="number"
          className="w-32 bg-background/40 text-foreground"
          value={Number.isFinite(value) ? value : ""}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
          onChange={(event) => onChange(Number(event.target.value))}
        />
      </div>
    </div>
  );
}

export default MCSettingNumber;
